import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpModule } from '@angular/http'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { StorageServiceModule } from 'ngx-webstorage-service'

import { AppComponent } from "./app.component";
import { MoviesListComponent } from './movieslist/movies-list.component';
import { NavigationComponent } from './navigation/navigation.component';
import { routes } from './routes';
import { MoviesearchComponent } from './moviesearch/moviesearch.component';
import { LatestmoviesComponent } from './latestmovies/latestmovies.component';
import { FullmovieComponent } from './fullmovie/fullmovie.component';
import { FavoritesComponent } from './favorites/favorites.component'
import { Favorites } from './fullmovie/favorite'

@NgModule({
  declarations: [AppComponent, MoviesListComponent, NavigationComponent, MoviesearchComponent, LatestmoviesComponent, FullmovieComponent, FavoritesComponent],
  imports: [BrowserModule, RouterModule.forRoot(routes), HttpModule, FormsModule, StorageServiceModule],
  bootstrap: [AppComponent],
  providers: [Favorites]
})
export class AppModule { }
